import { useState } from 'react'
import { UserPlus } from 'lucide-react'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@components/ui/table'
import { Button } from '@/components/ui/button'
import { useCurrentUser } from '@contexts/currentUser'

import CollaboratorsListActions from './CollaboratorsListActions'
import AddCollaboratorsModal from './AddCollaboratorsModal'

const Collaborators = ({ classroomId, collaborators, classroomOwner, refetch }) => {
  const { user: { profile_id: profileId } = {} } = useCurrentUser()

  const [showAddCollaboratorsModal, setShowAddCollaboratorsModal] = useState(false)

  const educators = [
    { ...classroomOwner, role: 'owner' },
    ...collaborators.map(collaborator => ({ ...collaborator, role: 'collaborator' }))
  ]

  return (
    <div className='flex flex-col gap-4 mt-4 mx-5'>
      <If condition={profileId === classroomOwner.id}>
        <Button
          label='Add collaborators'
          className='self-end'
          theme='light'
          onClick={() => setShowAddCollaboratorsModal(true)}>
          <UserPlus size={16} />
          Add collaborators
        </Button>
      </If>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead />
            <TableHead />
          </TableRow>
        </TableHeader>

        <TableBody>
          <For each='educator' of={educators}>
            <TableRow key={educator.id}>
              <TableCell>
                {educator.fullName}
              </TableCell>

              <TableCell>
                {educator.email}
              </TableCell>

              <TableCell>
                {educator.role}
              </TableCell>

              <TableCell className='text-right'>
                <CollaboratorsListActions
                  id={educator.id}
                  classroomId={classroomId}
                  isOwner={educator.role === 'owner'}
                  currentUserIsOwner={profileId === classroomOwner.id}
                  currentUserIsCollaborator={profileId === educator.id}
                  refetchCollaborators={refetch}
                />
              </TableCell>
            </TableRow>
          </For>
        </TableBody>
      </Table>

      <AddCollaboratorsModal
        classroomId={classroomId}
        classroomOwner={classroomOwner}
        isOpen={showAddCollaboratorsModal}
        closeModal={() => setShowAddCollaboratorsModal(false)}
        refetchCollaborators={refetch}
        currentCollaborators={collaborators}
      />
    </div >
  )
}

export default Collaborators
